import { Injectable } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { AppService } from "./app.service";
@Injectable({
    providedIn: 'root'
})
export class RolePermissionService {
    public _appName: string = null;
    constructor(private activatedRoute: ActivatedRoute, private appService: AppService) { }

    getActiveRouteResource() {
        let currentRoute = this.activatedRoute.root;
        let lastRoute: any = null;
        do {
            const childrenRoutes = currentRoute.children;
            currentRoute = null;
            for (let r in childrenRoutes) {
                let route = childrenRoutes[r];
                if (route.outlet == 'primary') {
                    const routeSnapshot = route.snapshot;
                    if (routeSnapshot) {
                        currentRoute = route;
                        if (routeSnapshot.firstChild == null && routeSnapshot.data != undefined && routeSnapshot.data.resource != undefined) {
                            lastRoute = routeSnapshot.data.resource;
                        }
                    }
                }
            }
        } while (currentRoute)

        if (lastRoute) {
            return lastRoute;
        } else {
            return null;
        }
    }
    checkAccessPermission(type = 'get', resource: any = false, application: any = false) {

        //TODO: if superadmin return true
        if (!resource) {
            resource = this.getActiveRouteResource();
        }
        if (!resource) {
            return false;
        }
        if (application) {
            var rolePermission = this.getCurrentApplicationPermisstionObj(application);
        } else {
            var rolePermission = this.getCurrentApplicationPermisstionObj();
        }

        if (rolePermission && Object.keys(rolePermission).length) {
            var found: any = false;
            if (rolePermission[resource] != undefined) {
                found = rolePermission[resource];
            }
            if (found && found.resource_permissions != undefined) {
                if (found.resource_permissions[type] != undefined && found.resource_permissions[type]) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return false; //TODO: if there is no permission for current application we will  disallow all permission.
        }
    }

    getCurrentApplicationPermisstionObj(application: any = false) {
        var obj = this.appService._permissions;
        if (obj != null && Object.keys(obj).length) {
            if (application) {
                var permission = obj[application];
            } else {
                var permission = obj[this.appService.getApplication()];
            }
            if (permission != undefined) {
                return permission;
            } else {
                return [];
            }
        } else {
            return [];
        }
    }

    parseMenuItemForPermission(menuObj, parent: any = {}, application = false) {
        var validElements = [];
        for (let index = 0; index < menuObj.length; index++) {
            const element = menuObj[index];

            //TODO: handle superadmin permission if any

            if (element.resource != undefined && element.resource) {
                if (element.check_permission != undefined) {
                    if (element.check_permission) {
                        if (this.checkAccessPermission('get', element.resource, application)) {
                            if (parent.data != undefined && element.appendedData == undefined) {
                                element.data = parent.data;
                                element.appendedData = true;
                            }
                            validElements.push(element);
                        }
                    } else {
                        if (parent.data != undefined && element.appendedData == undefined) {
                            element.data = parent.data;
                            element.appendedData = true;
                        }
                        validElements.push(element);
                    }
                } else {
                    if (this.checkAccessPermission('get', element.resource, application)) {
                        if (parent.data != undefined && element.appendedData == undefined) {
                            element.data = parent.data;
                            element.appendedData = true;
                        }
                        validElements.push(element);
                    }
                }
            } else {
                if (element.children != undefined && element.children.length) {
                    element.children = this.parseMenuItemForPermission(element.children, element, application)
                }

                //CHECK IF it has children still after permission handling, allow if it has url (case of custom routes)
                if ((element.children != undefined && element.children.length) || element.url != undefined) {
                    validElements.push(element);
                }
            }
        }
        return validElements;
    }

    getAllowedTabs(tabList) {
        var finalList = [];
        for (let index = 0; index < tabList.length; index++) {
            var resource = '';
            let actionObj = tabList[index];
            var application = (actionObj.application != undefined) ? actionObj.application : false;

            actionObj.permission_required = true;   // making this byDefault true for rbac
            
            if (actionObj.component != undefined && actionObj.component != "")
                resource = actionObj.component['resource'] != undefined ? actionObj.component['resource'] : actionObj.component['selector'];
            else
                resource = actionObj.resource_name || actionObj.resource;
            if (resource == undefined || resource == '' || (actionObj.child_tab != undefined && actionObj.child_tab)) {
                if (actionObj.resource == undefined) {
                    finalList.push(actionObj);
                } else if (actionObj.permission_required != undefined && !actionObj.permission_required) {
                    finalList.push(actionObj);
                } else {
                    if (this.checkAccessPermission(actionObj.action_name || action, resource, application)) {
                        finalList.push(actionObj);
                    }
                }
            } else {
                var action = (actionObj.action != undefined && ['add', 'modify'].indexOf(actionObj.action.toLowerCase()) > -1) ? actionObj.action.toLowerCase() : 'get';


                if (actionObj.permission_required != undefined && actionObj.permission_required) {
                    if (this.checkAccessPermission(actionObj.action_name || action, resource, application)) {
                        finalList.push(actionObj);
                    }
                } else if (actionObj.permission_required != undefined && !actionObj.permission_required) {
                    finalList.push(actionObj);
                } else {
                    if (this.checkAccessPermission(actionObj.action_name || action, resource, application)) {
                        finalList.push(actionObj);
                    }
                }
            }
        }
        return finalList;
    }

    getAllowedContextMenu(listFields, capability, resource?, type?) {
        // console.log("ndhdjkndj ", listFields, capability);
        let ellipseObj;
        let ellipseIndex = 0;
        if (listFields != undefined && listFields){
            ellipseObj = listFields.find(x => x.config !== undefined && x.config.type !== undefined && x.config.type === 'ellipse');
        }
        const listLength = listFields.length;
        if (capability && capability.length && ((listFields[listLength - 1] != undefined && listFields[listLength - 1].config == undefined) || (!listFields))) {
            let obj = {};
            if (ellipseObj != undefined && ellipseObj) {
                obj = ellipseObj;
                ellipseIndex = listFields.findIndex(x => x.config !== undefined && x.config.type !== undefined && x.config.type === 'ellipse');
            } else {
                obj['heading'] = "";
                obj['order'] = listLength + 1;
                obj['sortable'] = false;
                obj['name'] = "";
            }
            var allowed = [];
            if (listFields && !ellipseObj) {
                listFields.push(obj);
            }

            //listFields.splice(listLength, 0, abc);
            for (let index = 0; index < capability.length; index++) {
                let actionObj = capability[index];
                var application = false;
                if (actionObj.permission_required != undefined && actionObj.permission_required) {
                    if (this.checkAccessPermission(actionObj.action_name || actionObj.action, resource, application)) {
                        console.log("In access permission required ");
                        if (listFields && (listFields[listLength] != undefined || listFields[ellipseIndex] != undefined)) {
                            this.actionMenu(listFields, actionObj, type);
                        }
                        allowed.push(actionObj);
                    }
                } else if (actionObj.permission_required != undefined && !actionObj.permission_required) {
                    console.log("In permission required ");
                    if (listFields && (listFields[listLength] != undefined || listFields[ellipseIndex] != undefined)) {
                        this.actionMenu(listFields, actionObj, type);
                    }
                    allowed.push(actionObj);
                } else {
                    if (this.checkAccessPermission(actionObj.action_name || actionObj.action, resource, application)) {
                        console.log("In else required ");
                        if (listFields && (listFields[listLength] != undefined || listFields[ellipseIndex] != undefined)) {
                            this.actionMenu(listFields, actionObj, type);
                        }
                        allowed.push(actionObj);
                    }
                }
            }
        }
        console.log("List Fields in role permission", listFields);
        if (listFields) {
            return listFields;
        } else {
            return allowed;
        }

    }

    actionMenu(listFields, actionObj, type) {
        let ellipseIndex = listFields.findIndex(x => x.config !== undefined && x.config.type !== undefined && x.config.type === 'ellipse');
        const listLength = ellipseIndex > 0 ? ellipseIndex : listFields.length - 1;

        if (listFields[listLength].config == undefined) {
            listFields[listLength].config = {};
            listFields[listLength].config.type = type != undefined ? type : 'ellipse';
            listFields[listLength].config.buttonMenu = [];
            listFields[listLength].config['showSettings']=type != undefined ? true : false;
        }
        listFields[listLength].config.buttonMenu.push(actionObj);
    }

    checkIfEnabled(feature){
        return true;//it was making enabling AI unncessary complicated so removed it now it will just conrolled by rbac on resource and AI agent assignment to users
        // var accountConfig = this.appService.getAccountConfig();
        // if(accountConfig && accountConfig[feature] != undefined && accountConfig[feature]){
        //     return true;
        // }else{
        //     return false;
        // }
    }

    checkdecimalConfig(){
        return this.appService._currentSessionData.currency_decimal_limit ?this.appService._currentSessionData.currency_decimal_limit : false;
    }
    addSettingButton(listFields){
        // listFields['config'] = {
        //     "type": "ellipse",
        //     "buttonMenu": []
        // }
    }
    

}